import { render, staticRenderFns } from "./wsGrxx.vue?vue&type=template&id=12caa6b6&scoped=true"
import script from "./wsGrxx.vue?vue&type=script&lang=js"
export * from "./wsGrxx.vue?vue&type=script&lang=js"
import style0 from "./wsGrxx.vue?vue&type=style&index=0&id=12caa6b6&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12caa6b6",
  null
  
)

export default component.exports